import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getVariantTags = {
  name: "getVariantTags" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ tags: z.array(z.string()) }),
};
